import React from 'react';
import { createFieldByType } from './utils/createFieldByType';
import { formCategories, staticBlocks, complexFields } from './utils/paletteConfig'; //, layoutBlocks
import './css/palette-panel.css';
export default function FieldPalette({ onAddField }) {
  const handleAddClick = async (type, title) => {
    try {
      const newField = await createFieldByType(
        type,
        () => ({
          id: Date.now().toString(),
          type,
          title,
          name: type,
        })
      );
      onAddField(newField);
    } catch (err) {
      console.error(`Erreur lors de la création du champ "${type}":`, err);
    }
  };

  return (
    <div className="accordion" id="paletteAccordion">
      {/* === Champs standards === */}
      {formCategories.map((cat, idx) => (
        <AccordionSection
          key={cat.id}
          id={cat.id}
          title={cat.title}
          items={cat.fields}
          variant="secondary"
          defaultOpen={idx === 0}
          onAdd={handleAddClick}
        />
      ))}

      {/* === Contenu statique === */}
      <AccordionSection
        id="static"
        title="📄 Contenu statique"
        items={staticBlocks}
        variant="dark"
        onAdd={handleAddClick}
      />

      {/* === Champs complexes === */}
      <AccordionSection
        id="complex"
        title="🧩 Champs complexes"
        items={complexFields}
        variant="primary"
        onAdd={handleAddClick}
      />
      {/* === Mise en page === */}
      {/*
      <AccordionSection
        id="layout"
        title="📐 Mise en page"
        items={layoutBlocks}
        variant="warning"
        onAdd={handleAddClick}
      />*/}
    </div>
  );
}

function AccordionSection({ id, title, items, onAdd, variant = 'secondary', defaultOpen = false }) {
  return (
    <div className="accordion-item">
      <h2 className="accordion-header" id={`heading-${id}`}>
        <button
          className={`accordion-button ${!defaultOpen ? 'collapsed' : ''}`}
          type="button"
          data-bs-toggle="collapse"
          data-bs-target={`#collapse-${id}`}
          aria-expanded={defaultOpen ? 'true' : 'false'}
          aria-controls={`collapse-${id}`}
        >
          {title}
        </button>
      </h2>
      <div
        id={`collapse-${id}`}
        className={`accordion-collapse collapse ${defaultOpen ? 'show' : ''}`}
        data-bs-parent="#paletteAccordion"
      >
        <div className="accordion-body p-1">
          {items.map((f) => (
            <button
              key={f.type}
              className={`btn btn-outline-${variant} w-100 mb-2 text-start`}
              onClick={() => onAdd(f.type, f.title)}
            >
              ➕ {f.title}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
